<template>
  <div>

    <Dialog :visible.sync="exibirModalNovo" header="Justificar" :modal="true" :style="{width: '55vw'}" @hide="fecharModal">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Data início</label>							
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>
            </div>  
            <div class="p-field p-col-12 p-md-6">
                <label>Data final</label>							
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>
            </div>            
        </div> 
        <TabView>
            <TabPanel header="Não Justificados" class="p-mt-3">                 
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Evento</label>							
                        <Dropdown v-model="idEventoSelecionado" :options="eventosNaoJustificados" 
                                        optionLabel="descricaoEventoReal" optionValue="id" placeholder="Selecione" appendTo="body"/>
                    </div>    
                    <div class="p-field p-col-12 p-md-6">
                        <label>Justificativa</label>							
                        <Dropdown v-model="idJustificativaSelecionada" :options="justificativas" 
                                        optionLabel="descricao" optionValue="id" placeholder="Selecione" appendTo="body"/>
                    </div>  
                    <div class="p-field p-col-12 p-md-12">
                        <label>Observação</label>
                        <Textarea v-model.trim="observacao" rows="5" cols="30" @keyup="contarCaracteres"/>
                    </div>             
                </div>
                <Button label="Incluir em justificados" icon="pi pi-check" @click="inluirJustificativa" />
            </TabPanel>
            <TabPanel header="Justificados" class="p-mt-3">
                <DataTable :value="eventosJustificados" class="p-datatable-sm p-datatable-striped">           
                    <Column field="desfazer" header="Excluir">    
                        <template #body="slotProps">
                            <Checkbox v-model="slotProps.data.desfazer" :binary="true" @click="removerSemSalvar(slotProps.data)"/>
                        </template> 
                    </Column>          
                    <Column field="justificativa.descricao" header="Justificativa"></Column> 
                    <Column field="descricaoEventoReal" header="Evento"></Column>           
                </DataTable>
            </TabPanel>
        </TabView>  				
        <template #footer>
            <div class="p-d-flex p-jc-between">
                <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>
                <div>
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                    <Button label="Salvar" icon="pi pi-check" @click="salvar" />
                </div>                              
            </div>            
        </template>        
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, exibirMensagemSis, clonar, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            idEventoSelecionado: null,
            idJustificativaSelecionada: null,
            dataPonto: null,
            exibirModalNovo: false,
            dataInicio: new Date(),
            dataFinal: new Date(),
            eventosJustificados: [],
            eventosNaoJustificados: [],
            justificativas: [],
            requisicao: {},
            observacao: '',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {   
            this.requisicao = {...req};                     
            this.controlePontoService.listarEventos(req)
            .then(resp => {
                this.dataPonto = this.formatarStringData(req.dataPonto);
                this.dataInicio = this.formatarStringData(req.dataPonto);                
                this.dataFinal = this.formatarStringData(req.dataPonto);
                this.eventosJustificados = resp.data.justificados;
                this.eventosNaoJustificados = resp.data.naoJustificados;
                this.justificativas =  resp.data.justificativas;
                this.exibirModalNovo = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },
        inluirJustificativa() {            
            if(this.idEventoSelecionado == null || this.idJustificativaSelecionada == null) {
                exibirMensagemSis(this, 'Selecione um evento e uma justificativa', true);
                return;
            }
            let eventoSelecionado = null;
            let indexRemover = 0;
            this.eventosNaoJustificados.forEach((evento, index) => {               
                if(evento.id == this.idEventoSelecionado) {
                    eventoSelecionado = evento;
                    indexRemover = index;
                }
            });
            this.eventosNaoJustificados.splice(indexRemover, 1);          
            eventoSelecionado.selecionar = true;
            eventoSelecionado.novoJustificar = true;
            this.justificativas.forEach(just => {
                if(just.id == this.idJustificativaSelecionada) {
                    eventoSelecionado.justificativa = just;
                }
            });
            this.idEventoSelecionado = null;
            this.idJustificativaSelecionada = null;
            if(this.observacao) {
                eventoSelecionado.observacao = this.observacao;
            }
            let usuario = this.getDadosRequisicao().usuario;
            eventoSelecionado.usuarioJustificativa = usuario.nome + '-' + usuario.email.split('@')[0];
            this.observacao = '';
            this.eventosJustificados.push(eventoSelecionado);
        },
        removerSemSalvar(eventoSelecionado) {
            if(eventoSelecionado.novoJustificar) {
                let indexRemover = 0;
                this.eventosJustificados.forEach((evento, index) => {               
                    if(evento.id == eventoSelecionado.id) {                      
                        indexRemover = index;
                    }
                });
                this.eventosJustificados.splice(indexRemover, 1);  
                eventoSelecionado.justficativa = null;
                eventoSelecionado.usuarioJustificativa = null;
                eventoSelecionado.observacao = null;
                eventoSelecionado.selecionar = false;
                eventoSelecionado.desfazer = false;
                this.eventosNaoJustificados.push(eventoSelecionado);
            }
        },        
        salvar() {      
            if(this.eventosJustificados.length == 0) {
                exibirMensagemSis(this, 'Nenhum evento selecionado', true);
                return;
            }   
            this.requisicao['dataInicio'] = this.formatarData(this.dataInicio);
            this.requisicao['dataFinal'] = this.formatarData(this.dataFinal);
            this.requisicao['eventos'] = clonar(this.eventosJustificados);
            this.controlePontoService.salvarEventosJustificativas(this.requisicao)
            .then(resp => {
                exibirMensagem(this, resp);		
                this.callback(this.requisicao.dataInicio, this.requisicao.dataFinal);
                this.fecharModal(); 
            })
            .catch(erro => {                
                exibirMensagem(this, erro)
            });    
        },
        contarCaracteres() {
            if(this.observacao.length > 300) {
                this.observacao = this.observacao.substring(0, 300);
            }
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},    
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },    
        fecharModal() {
            this.exibirModalNovo = null;    
            this.eventosJustificados = [];
            this.eventosNaoJustificados = [];
            this.justificativas = [];            
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style>

</style>